import { render, staticRenderFns } from "./success-tip.vue?vue&type=template&id=1b50ac36&"
import script from "./success-tip.vue?vue&type=script&lang=js&"
export * from "./success-tip.vue?vue&type=script&lang=js&"
import style0 from "./success-tip.vue?vue&type=style&index=0&id=1b50ac36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports